import React, { useEffect, useRef, useState } from 'react'
import './topbar.css'
import logo from '../../assets/images/logo.jpg'
import userlogo from '../../assets/images/userLogo.png'
import { AddToQueue, Campaign, Clear, Create, Menu, Person,List } from "@mui/icons-material";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { adminLogoutData } from '../../features/adminLogout/adminLogoutSlice';


const Topbar = () => {
  const dispatch = useDispatch();
  const menuRef = useRef()
  let pathname = window.location.pathname
  const navigate = useNavigate();
  const [accessToken, setaccessToken] = useState()


  // if(pathname === '/admin/login' ){
  //   setisAccessToken(false)
  // }else{
  //   setisAccessToken(true);
  // }

  useEffect(()=>{
    const isAccessToken = localStorage.getItem('access_token')
    if(isAccessToken === null){
      navigate('/admin/login')
    }
    setaccessToken(isAccessToken)
  },[pathname])
  // console.log(accessToken)

  const showMenuBar = ()=>{
    menuRef.current.classList.toggle('responsive_menu')
  }

  const handleClick = () => {   
    
    
    
    dispatch(adminLogoutData(accessToken))
    localStorage.removeItem('access_token');
    setaccessToken(null)
    navigate("/admin/login");
    // window.location.href = 'http://localhost:3000/admin/campaign-detail'
  };
  return (
    <div className='topbar'>
      <div className='topbarWrapper'>
        <div className='topLeft'>
            <img src={logo} alt="" />
        </div>
        <div className='loginLogout'>
          {accessToken !== null ? (<div className='logout' onClick={() => handleClick()}>Logout<div className='userLogoImage'><img  src={userlogo} alt="" /></div></div>):(<div className='login'>Login </div>)}
        </div>
        <div className='dropDownMenu' ref = {menuRef} >
          <Clear className='clearMenu' onClick={showMenuBar}/>
          <h3 className="sidebarTitle">Ad Manager</h3>
        <ul className="sidebarList">
            <Link to = '/admin/all-campaign' onClick={showMenuBar} >
            <li className="sidebarListItem ">
              <Campaign className="sidebarIcon" />
              All Campaign
            </li>
            </Link>
            
           <Link to = '/admin/create-campaign'  onClick={showMenuBar} >
            <li className="sidebarListItem " >
              < Create className="sidebarIcon "/>
              Create New Campaign
            </li>
            </Link>
           
          </ul>

          <h3 className="sidebarTitle">Cricway</h3> 
           <ul className="sidebarList">
           <Link to = '/admin/series-list'  onClick={showMenuBar} >
            <li className="sidebarListItem " >
              <List className="sidebarIcon" />
              All Series
            </li>
            </Link>
            <Link to = '/admin/add-products'  onClick={showMenuBar} >
            <li className="sidebarListItem " >
              <AddToQueue className="sidebarIcon" />
              Add Products
            </li>
            </Link>
            <Link to = '/admin/all-reward-products'  onClick={showMenuBar} >
            <li className="sidebarListItem " >
              <List className="sidebarIcon" />
              All Products
            </li>
            </Link>
                    
          </ul>
          <h3 className="sidebarTitle">Account</h3> 
           <ul className="sidebarList">
          
            <Link to = '/admin/login'  onClick={showMenuBar} >
            <li className="sidebarListItem " >
              <Person className="sidebarIcon" />
              <div className='loginLogoutDropdown'>
          {accessToken !== null ? (<div className='logoutDropdown' onClick={handleClick}>Logout</div>):(<div className='loginDropdown'>Login </div>)}
        </div>
            </li>
            </Link>
                    
          </ul>
        </div>
        {accessToken !== null ? (<div className='topRight' >
          
          <Menu className='menuIcon' onClick={showMenuBar}/>
      </div>) : <div></div>}
        
      </div>


    </div>
  )
}

export default Topbar
